import React, { useEffect, useRef } from 'react'
import { AgCharts } from 'ag-charts-community'

/**
 * NewPlanChart - purpose-built for the new planning UI.
 * Accepts periodData array directly instead of a Map to avoid stale closure issues.
 *
 * periodData: Array of { period, shortPeriod, salesPlan, markdownPlan, planInvBOM, planInflowRetail }
 * xKeyLabel: 'week' | 'month'
 */
const NewPlanChart = ({ periodData = [], xKeyLabel = 'week' }) => {
  const chartDivRef = useRef(null)
  const chartInstanceRef = useRef(null)

  useEffect(() => {
    if (!chartDivRef.current) return

    const data = (periodData || []).map((p) => ({
      [xKeyLabel]: p?.shortPeriod || p?.period || '',
      Sales: Number(p?.salesPlan || 0) / 1000,
      Inventory: Number(p?.planInvBOM || 0) / 1000,
      Markdowns: Number(p?.markdownPlan || 0) / 1000,
      InflowRetail: Number(p?.planInflowRetail || 0) / 1000,
    }))

    const options = {
      container: chartDivRef.current,
      data,
      series: [
        { type: 'line', xKey: xKeyLabel, yKey: 'Sales', yName: 'Sales Plan', marker: { fill: '#008000', stroke: '#008000' }, stroke: '#008000' },
        { type: 'area', xKey: xKeyLabel, yKey: 'Inventory', yName: 'Inventory BOM', fill: 'yellow', fillOpacity: 0.5, stroke: '#cccc00' },
        { type: 'line', xKey: xKeyLabel, yKey: 'InflowRetail', yName: 'Plan Inflow Retail', marker: { fill: '#800080', stroke: '#800080' }, stroke: '#800080' },
        { type: 'line', xKey: xKeyLabel, yKey: 'Markdowns', yName: 'Markdowns Plan', marker: { fill: '#FF0000', stroke: '#FF0000' }, stroke: '#FF0000' },
      ],
      axes: [
        { type: 'category', position: 'bottom', label: { rotation: 45 } },
        { type: 'number', position: 'left', label: { enabled: false } },
      ],
      legend: { enabled: false },
    }

    if (chartInstanceRef.current) {
      chartInstanceRef.current.update(options)
    } else {
      chartInstanceRef.current = AgCharts.create(options)
    }
  }, [periodData, xKeyLabel])

  useEffect(() => {
    return () => {
      if (chartInstanceRef.current) {
        try { chartInstanceRef.current.destroy?.() } catch (e) { /* ignore */ }
        chartInstanceRef.current = null
      }
    }
  }, [])

  return <div ref={chartDivRef} style={{ width: '110%', height: 250 }} />
}

export default NewPlanChart

